import React, { useMemo } from 'react';
import s from './s.module.less';
import dayjs from 'utils/dayjs';
import { Button, Space, Dropdown, Input, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { EBillingStatus, EBillingStatusLabel } from 'types/provider';
import StatusLabel from 'components/ManageSubscription/components/StatusLabel';
import { ColumnType } from 'antd/es/table';
import CommonTable from 'components/CommonTable';
import usePaymentBillingLeadgenFeeList from 'hooks/usePaymentBillingLeadgenFeeList';
import useKlarityServiceTemplate from 'hooks/useKlarityServiceTemplate';
import {
    ELeadGenBillingStatus,
    ELeadGenOrderKey,
    TBillingLeadGenFeeItem,
    TGetPaymentBillingLeadgenFeeList,
} from 'types/financials';
import { isLocalhost } from 'utils/common';
import { getUserToken } from 'utils/localstore';
import axios from 'axios';
import BillingPortalButton from 'components/BillingPortalButton';
import useKanmonConnect from 'hooks/useKanmonConnect';
import { getInvoiceViewUrl } from 'api/financials';
import ProviderCell from 'components/ProviderCell';

interface Props {
    clientId?: number;
    isPractice?: boolean;
}
const BillingLeadGenTable = ({ clientId, isPractice = false }: Props) => {
    const [specialtyFilter, setSpecialtyFilter] = React.useState<string[]>([]);
    const [searchAppidText, setSearchAppidText] = React.useState('');
    const [searchPendingAppidText, setSearchPendingAppidText] = React.useState('');

    const [searchProviderText, setSearchProviderText] = React.useState('');
    const [searchPendingProviderText, setSearchPendingProviderText] = React.useState('');

    const [searchDescriptionText, setSearchDescriptionText] = React.useState('');

    const [page, setPage] = React.useState(1);
    const [orderType, setOrderType] = React.useState<'ASC' | 'DESC'>('DESC');
    const [orderKey, setOrderKey] = React.useState<ELeadGenOrderKey | undefined>(undefined);
    const [billingStatus, setBillingStatus] = React.useState<ELeadGenBillingStatus[]>([]);
    const [kanmonConnect, kanmonInfo, loadingKanmonConnect, refetchKanmonInfo] = useKanmonConnect();
    // const [specialtiesOptions] = useGetSpecialtiesAndConditions({ isOps: false });
    const [templateDataState] = useKlarityServiceTemplate();
    const [dataList, listTotal, loading, refetch] = usePaymentBillingLeadgenFeeList(undefined, isPractice);
    const [viewingId, setViewingId] = React.useState<number | undefined>(undefined);

    const specialties: string[] = useMemo(() => {
        const ret: string[] = [];
        if (templateDataState) {
            templateDataState.recommend.forEach((item) => {
                ret.push(item.specialtyName);
            });
            templateDataState.other.forEach((item) => {
                ret.push(item.specialtyName);
            });
        }
        return ret;
    }, [templateDataState]);

    const handleShowKanmonModal = () => {
        kanmonConnect?.show();
    };

    // 处理表格变化
    const handleTableChange = (paginationData: any, filtersData?: any, sorter?: any, action?: any) => {
        if (action?.action === 'paginate') {
            setPage(paginationData.current!);
            return;
        }

        if (sorter) {
            setOrderType(sorter.order === 'ascend' ? 'ASC' : 'DESC');
            if (
                sorter.column?.dataIndex === 'appointmentGenFee' ||
                sorter.column?.dataIndex === 'appointmentGenFeeAmount'
            ) {
                setOrderKey(ELeadGenOrderKey.APPOINTMENT_GEN_FEE);
            }
            if (sorter.column?.dataIndex === 'appointmentDateTime') {
                setOrderKey(ELeadGenOrderKey.APPOINTMENT_DATE_TIME);
            }
            if (sorter.column?.dataIndex === 'rescheduledDateTime') {
                setOrderKey(ELeadGenOrderKey.RESCHEDULED_DATE_TIME);
            }
            if (sorter.column?.dataIndex === 'transactionDate') {
                setOrderKey(ELeadGenOrderKey.TRANSACTION_DATE);
            }
            if (sorter.column?.dataIndex === 'state') {
                setOrderKey(ELeadGenOrderKey.STATE);
            }
        }
        if (filtersData) {
            setBillingStatus(filtersData.billingStatus || []);
            setSpecialtyFilter(filtersData.specialty || []);
        }
    };

    const refetchData = () => {
        const filter: Partial<TGetPaymentBillingLeadgenFeeList> = {};
        filter.current = page;
        filter.size = 10;
        if (orderKey) {
            filter.leadGenOrderKey = orderKey;
        }
        if (orderType) {
            filter.orderType = orderType;
        }
        if (billingStatus && billingStatus.length > 0) {
            filter.billingStatus = billingStatus;
        }
        if (specialtyFilter && specialtyFilter.length > 0) {
            filter.specialty = specialtyFilter;
        }
        if (searchAppidText) {
            filter.appointmentId = searchAppidText;
        }
        if (searchProviderText) {
            filter.providerName = searchProviderText;
        }
        refetch(filter);
    };

    const handleDownload = async (item: TBillingLeadGenFeeItem) => {
        const baseURL = isLocalhost() ? 'https://dev.boxpractice.com/' : `${window.location.origin}/`;
        const url = `${baseURL}schedule-server/provider/stripe/invoice/${item.billingId}/pdf-url?billingId=${item.billingId}`;
        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                accept: 'application/json, text/plain, */*',
                'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
                'cache-control': 'no-cache',
                origin: `${baseURL}`,
                pragma: 'no-cache',
                priority: 'u=1, i',
                referer: `${baseURL}`,
                // 'sec-ch-ua': '"Google Chrome";v="135", "Not-A.Brand";v="8", "Chromium";v="135"',
                // 'sec-ch-ua-mobile': '?0',
                // 'sec-ch-ua-platform': '"macOS"',
                // 'sec-fetch-dest': 'empty',
                // 'sec-fetch-mode': 'cors',
                // 'sec-fetch-site': 'cross-site',
                token: getUserToken(),
                // 'user-agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/135.0.0.0 Safari/537.36',
                // 'Cookie': 'AWSALB=HH/eRDC1k7Dn6U2etvWV4a4ZkQCrxxBlk1kwXGDIoCiDu+gynKNqanH4yzp59vf8Gi3IXv45aZlQRcOmy9vP7YP5MvPl82D33rnWWonlXyKt7wASSlOUgKXp3LTD; AWSALBCORS=HH/eRDC1k7Dn6U2etvWV4a4ZkQCrxxBlk1kwXGDIoCiDu+gynKNqanH4yzp59vf8Gi3IXv45aZlQRcOmy9vP7YP5MvPl82D33rnWWonlXyKt7wASSlOUgKXp3LTD'
            },
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = downloadUrl;
        a.download = `${item?.billingId}.pdf`; // 可以根据需要调整

        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
    };

    const handleView = async (item: TBillingLeadGenFeeItem) => {
        setViewingId(item.billingId);
        const res = await getInvoiceViewUrl(item.billingId);
        if (!res.error) {
            const url = res.data.data;
            if (url) {
                window.open(url, '_blank');
            } else {
                message.error('Failed to load the invoice. Please try again.');
            }
        }
        setViewingId(undefined);
    };

    React.useEffect(() => {
        refetchData();
    }, [page, orderType, orderKey, billingStatus, specialtyFilter, searchAppidText, searchProviderText]);

    const allColumns: ColumnType<TBillingLeadGenFeeItem>[] = [
        {
            title: 'APPOINTMENT ID',
            dataIndex: 'appointmentId',
            key: 'appointmentId',
            filterDropdown: (props: any) => (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder="Search by specialty"
                        value={searchPendingAppidText}
                        onChange={(e) => setSearchPendingAppidText(e.target.value)}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => {
                                setSearchAppidText(searchPendingAppidText);
                                props.confirm();
                            }}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Search
                        </Button>
                        <Button
                            onClick={() => {
                                setSearchPendingAppidText('');
                                setSearchAppidText('');
                                props.clearFilters();
                            }}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Reset
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered: boolean) => (
                <SearchOutlined
                    style={{
                        color: filtered || searchDescriptionText ? '#1890ff' : undefined,
                    }}
                />
            ),
            onFilter: () => true, // 我们使用自己的过滤逻辑
        },
        {
            title: 'SPECIALTY',
            dataIndex: 'specialty',
            key: 'specialty',
            width: 200,
            render: (specialty: string, item: TBillingLeadGenFeeItem) => (
                <div>
                    <div className={s.providerName}>{specialty}</div>
                </div>
            ),
            filters: specialties.map((specialty) => ({
                text: specialty,
                value: specialty,
            })),
            filteredValue: specialtyFilter,
            onFilter: () => true, // 我们使用自己的过滤逻辑
        },
        {
            title: 'STATE',
            dataIndex: 'state',
            key: 'state',
            width: 150,
            sorter: (a: TBillingLeadGenFeeItem, b: TBillingLeadGenFeeItem) =>
                a.state?.localeCompare(b.state || '') || 0,
        },
        ...(isPractice
            ? [
                  {
                      title: 'PROVIDER',
                      key: 'providerName',
                      width: 150,
                      filterDropdown: (props: any) => (
                          <div style={{ padding: 8 }}>
                              <Input
                                  placeholder="Search by provider"
                                  value={searchPendingProviderText}
                                  onChange={(e) => setSearchPendingProviderText(e.target.value)}
                                  onPressEnter={() => {
                                      setSearchProviderText(searchPendingProviderText);
                                      props.confirm();
                                  }}
                                  style={{ marginBottom: 8, display: 'block' }}
                              />
                              <Space>
                                  <Button
                                      type="primary"
                                      onClick={() => {
                                          setSearchProviderText(searchPendingProviderText);
                                          props.confirm();
                                      }}
                                      icon={<SearchOutlined />}
                                      size="small"
                                      style={{ width: 90 }}
                                  >
                                      Search
                                  </Button>
                                  <Button
                                      onClick={() => {
                                          setSearchPendingProviderText('');
                                          setSearchProviderText('');
                                          props.clearFilters();
                                      }}
                                      size="small"
                                      style={{ width: 90 }}
                                  >
                                      Reset
                                  </Button>
                              </Space>
                          </div>
                      ),
                      filterIcon: (filtered: boolean) => (
                          <SearchOutlined
                              style={{
                                  color: filtered || searchProviderText ? '#1890ff' : undefined,
                              }}
                          />
                      ),
                      onFilter: () => true, // 我们使用自己的过滤逻辑
                      render: (_: string, record: TBillingLeadGenFeeItem) => (
                          <ProviderCell
                              name={record.providerName}
                              avatar={record.providerAvatar}
                              credential={record.providerCredential}
                          />
                      ),
                  } as ColumnType<TBillingLeadGenFeeItem>,
              ]
            : []),
        {
            title: 'APPOINTMENT GEN FEE',
            dataIndex: 'appointmentGenFeeAmount',
            key: 'appointmentGenFeeAmount',
            width: 200,
            sorter: (a: TBillingLeadGenFeeItem, b: TBillingLeadGenFeeItem) => a.appointmentGenFee - b.appointmentGenFee,
            render: (fee: number) => {
                return <div className={s.tableItem}>${fee}</div>;
            },
        },
        {
            title: 'STATUS',
            dataIndex: 'billingStatus',
            key: 'billingStatus',
            width: 150,
            render: (status: EBillingStatus, item: TBillingLeadGenFeeItem) => {
                return <StatusLabel value={status} />;
            },
            // export enum EBillingStatus {
            //     DISPUTE_OPEN = "Dispute open",
            //     DISPUTE_CLOSED = "Dispute closed",
            //     PENDING = "Pending",
            //     PAID = "Paid",
            //     FAILED = "Failed",
            //     CANCELLED = "Cancelled",
            //     NOT_READY = "Not ready",
            //     PROCESSING = "Processing",
            //     SUCCEEDED = "Succeeded",
            //     REFUND_PROCESSING = "Refund processing",
            //     REFUNDED = "Refunded",
            //     REFUND_FAILED = "Refund failed",
            //     DISPUTE_PROCESSING = "Dispute processing",
            //     DISPUTE_WON = "Dispute won",
            //     DISPUTE_LOST = "Dispute lost",
            // }
            filters: [
                {
                    value: ELeadGenBillingStatus.PENDING,
                    text: EBillingStatusLabel.PENDING,
                },
                {
                    value: ELeadGenBillingStatus.PROVIDER_NOT_READY,
                    text: EBillingStatusLabel.NOT_READY,
                },
                {
                    value: ELeadGenBillingStatus.PROCESSING,
                    text: EBillingStatusLabel.PROCESSING,
                },
                {
                    value: ELeadGenBillingStatus.SUCCEEDED,
                    text: EBillingStatusLabel.SUCCEEDED,
                },
                {
                    value: ELeadGenBillingStatus.FAILED,
                    text: EBillingStatusLabel.FAILED,
                },
                {
                    value: ELeadGenBillingStatus.CANCELED,
                    text: EBillingStatusLabel.CANCELED,
                },
            ],
            filteredValue: billingStatus,
            onFilter: (value: any, record: TBillingLeadGenFeeItem) => {
                return true;
            },
        },
        {
            title: 'APPOINTMENT DATE & TIME',
            dataIndex: 'appointmentDateTime',
            key: 'appointmentDateTime',
            width: 300,
            render: (appointmentOriginalDateTime: string, item: TBillingLeadGenFeeItem) => {
                if (!item.appointmentDateTime || !item.appointmentEndDateTime) {
                    return '-';
                }
                // 03/26/2023, 10:30 - 11:00 AM
                return (
                    <div className={s.date}>
                        {dayjs(appointmentOriginalDateTime).format('MM/DD/YYYY, HH:mm')} -{' '}
                        {dayjs(item.appointmentEndDateTime).format('HH:mm a')}
                    </div>
                );
            },
            sorter: (a: TBillingLeadGenFeeItem, b: TBillingLeadGenFeeItem) => {
                return new Date(a.appointmentDateTime).getTime() - new Date(b.appointmentDateTime).getTime();
            },
        },
        // {
        //     title: 'RESCHEDULED DATE & TIME',
        //     dataIndex: 'rescheduledDateTime',
        //     key: 'rescheduledDateTime',
        //     width: 300,
        //     render: (rescheduledDateTime: string, item: TBillingLeadGenFeeItem) => {
        //         if (!item.rescheduledDateTime || !item.rescheduledEndDateTime) {
        //             return '-';
        //         }
        //         // 03/26/2023, 10:30 - 11:00 AM
        //         return (
        //             <div className={s.date}>{dayjs(rescheduledDateTime).format('MM/DD/YYYY, HH:mm')} - {dayjs(item.rescheduledEndDateTime).format('HH:mm a')}</div>
        //         );
        //     },
        //     sorter: (a: TBillingLeadGenFeeItem, b: TBillingLeadGenFeeItem) => {
        //         return new Date(a.rescheduledDateTime || '').getTime() - new Date(b.rescheduledDateTime || '').getTime();
        //     },

        // },
        {
            title: 'TRANSACTION DATE',
            dataIndex: 'transactionDate',
            key: 'transactionDate',
            width: 200,
            render: (transactionDate: string, item: TBillingLeadGenFeeItem) => {
                if (!item.transactionDate) {
                    return '-';
                }
                // 03/26/2023, 10:30 - 11:00 AM
                return <div className={s.date}>{dayjs(transactionDate).format('MM/DD/YYYY')}</div>;
            },
            sorter: (a: TBillingLeadGenFeeItem, b: TBillingLeadGenFeeItem) => {
                return new Date(a.transactionDate || '').getTime() - new Date(b.transactionDate || '').getTime();
            },
        },
        {
            title: '',
            key: 'action',
            fixed: 'right',
            width: 100,
            render: (record: TBillingLeadGenFeeItem, item: TBillingLeadGenFeeItem) => {
                const showDownloadInvoice =
                    record.externalInvoicePlatform === 'STRIPE' && record.billingId && record.externalInvoiceId;
                const items: any = [
                    {
                        key: 'Download invoice',
                        label: (
                            <div
                                onClick={() => {
                                    handleDownload(record);
                                }}
                                className={s.popItem}
                            >
                                Download invoice
                            </div>
                        ),
                    },
                ].filter(Boolean);
                const isStripe = item.externalInvoicePlatform?.toLowerCase() === 'stripe';
                const isKanmon = kanmonConnect && item.externalInvoicePlatform?.toLowerCase() === 'kanmon';
                return (
                    <div className={s.tableActions}>
                        {isStripe && (
                            <Button
                                type="link"
                                onClick={() => {
                                    handleView(record);
                                }}
                                className={s.viewButton}
                                loading={viewingId === record.billingId}
                            >
                                View
                            </Button>
                        )}

                        {isKanmon && (
                            <Button type="link" onClick={handleShowKanmonModal} className={s.viewButton}>
                                View
                            </Button>
                        )}
                        {showDownloadInvoice && (
                            <Dropdown
                                menu={{
                                    items,
                                }}
                                trigger={['hover']}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M12.0004 7.20039C10.6749 7.20039 9.60039 6.12587 9.60039 4.80039C9.60039 3.47491 10.6749 2.40039 12.0004 2.40039C13.3259 2.40039 14.4004 3.47491 14.4004 4.80039C14.4004 6.12587 13.3259 7.20039 12.0004 7.20039Z"
                                        fill="#6B7280"
                                    />
                                    <path
                                        d="M12.0004 14.4004C10.6749 14.4004 9.60039 13.3259 9.60039 12.0004C9.60039 10.6749 10.6749 9.60039 12.0004 9.60039C13.3259 9.60039 14.4004 10.6749 14.4004 12.0004C14.4004 13.3259 13.3259 14.4004 12.0004 14.4004Z"
                                        fill="#6B7280"
                                    />
                                    <path
                                        d="M9.60039 19.2004C9.60039 20.5259 10.6749 21.6004 12.0004 21.6004C13.3259 21.6004 14.4004 20.5259 14.4004 19.2004C14.4004 17.8749 13.3259 16.8004 12.0004 16.8004C10.6749 16.8004 9.60039 17.8749 9.60039 19.2004Z"
                                        fill="#6B7280"
                                    />
                                </svg>
                            </Dropdown>
                        )}
                    </div>
                );
            },
        },
    ];

    const columns = clientId ? allColumns.filter((col) => col.key !== 'providerFirstName') : allColumns;

    return (
        <div className={s.wrap}>
            <CommonTable
                className={`commonTable ${s.paymentTable}`}
                columns={columns}
                data={dataList || []}
                loading={loading}
                bordered
                rowKey="appointmentId"
                onChange={handleTableChange}
                pagination={{
                    pageSize: 10,
                    current: page,
                    showSizeChanger: false,
                    total: listTotal,
                    showTotal: (total, range) => `${total} records`,
                }}
                scroll={{ x: 'max-content' }}
                locale={{
                    emptyText: 'No earnings yet',
                }}
            />
        </div>
    );
};

export default BillingLeadGenTable;
